<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import UserModal from "./UserModal.vue"
import UserEditModal from "./UserEditModal.vue"
import UserWalletModal from "./UserWalletModal.vue"
import UsersTable from "./UsersTable.vue"

import store from "../../state/store"

const title = "مدیریت کاربران"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت کاربران",
    active: true,
  },
])

const DEFAULT_USER = {
  id: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  password: "",
  password_confirmation: "",
  status: "",
}

const DEFAULT_USER_WALLET = {
  id: "",
  userId: "",
  walletBalance: "",
}

const userModel = ref({ ...DEFAULT_USER })
const userWalletModel = ref({ ...DEFAULT_USER_WALLET })
const showUserModal = ref(false)
const showUserEditModal = ref(false)
const showUserWalleModal = ref(false)

const showAddNewModal = () => {
  showUserModal.value = true
}

const showEditModal = () => {
  showUserEditModal.value = true
}

const showWalleModal = () => {
  showUserWalleModal.value = true
}

const editUser = (usr) => {
  userModel.value = usr
  showEditModal()
}

const walletUser = async (usrId) => {
  const { data } = await store.dispatch("getUserWallet", usrId)
  userWalletModel.value = {
    ...data.data,
  }
  if (userWalletModel.value.userId === undefined) {
    userWalletModel.value.userId = usrId
  }

  showWalleModal()
}

const onModalClose = () => {
  userModel.value = { ...DEFAULT_USER }
  userWalletModel.value = { ...DEFAULT_USER_WALLET }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="userList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست کاربران</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن کاربر
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- users table  -->

          <UsersTable @clickEdit="editUser" @clickWallet="walletUser" />

          <!-- add and edit user modal  -->

          <UserModal
            v-model="showUserModal"
            :user="userModel"
            @close="onModalClose"
          />

          <UserEditModal
            v-model="showUserEditModal"
            :user="userModel"
            @close="onModalClose"
          />

          <UserWalletModal
            v-model="showUserWalleModal"
            :userWallet="userWalletModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
